module.exports = __webpack_public_path__ + "static/media/Summary of Benefits - PPO Medicare Advantage - 2021.e4547d86.rtf";